import React from 'react';
import { HeroVariant41 } from '../components/HeroVariant41';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage41() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1633">
      <Navigation data-id="element-1634" />
      <main data-id="element-1635">
        <HeroVariant41 data-id="element-1636" />
        <WhyUs data-id="element-1637" />
        <Services data-id="element-1638" />
        <FAQ data-id="element-1639" />
        <Testimonials data-id="element-1640" />
        <Consultation data-id="element-1641" />
      </main>
      <Footer data-id="element-1642" />
      <CookieBanner data-id="element-1643" />
      <FloatingContact data-id="element-1644" />
    </div>;
}